/**
 * Pure classifiers for errors the app handles specially. No imports, so they
 * run under the plain-Node unit tests.
 */

/**
 * True for a 404 from a project fetch: the project was deleted or isn't on
 * the signed-in account.
 */
export function isProjectNotFoundError(error: unknown): boolean {
  return (
    (error as { response?: { status?: number } })?.response?.status === 404
  );
}

/** Minimum gap between automatic reloads, so a persistent failure can't loop. */
export const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

/**
 * True when a lazy-loaded chunk failed to load and the page hasn't just
 * reloaded for the same reason. After a deploy the hashed chunk an open tab
 * asks for no longer exists; reloading fetches the new release.
 */
export function shouldReloadForChunkError(
  error: unknown,
  lastReloadAt: number | null,
  now: number
): boolean {
  if ((error as { name?: unknown })?.name !== 'ChunkLoadError') return false;
  return (
    lastReloadAt === null || now - lastReloadAt >= CHUNK_RELOAD_COOLDOWN_MS
  );
}
